const {
  blockEditor: { InnerBlocks },
} = wp;

const Save = () => {
  return <InnerBlocks.Content />;
};

export default Save;
